// extracted by mini-css-extract-plugin
export default {"TagSearchForm":"TagSearch_TagSearchForm__7t6cv","form-label":"TagSearch_form-label__RJG0T"};